var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.classNames,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm._handleClick}},[(!_vm.isLoading)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.buttonLabel)))]):_c('div',{staticClass:"redirect-spinner-wrapper"},[_c('spinner-button')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }